import { render, staticRenderFns } from "./aigc.vue?vue&type=template&id=5bff05be&scoped=true&"
import script from "./aigc.vue?vue&type=script&lang=js&"
export * from "./aigc.vue?vue&type=script&lang=js&"
import style0 from "./aigc.vue?vue&type=style&index=0&id=5bff05be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff05be",
  null
  
)

export default component.exports